import { useDispatch } from 'react-redux'
import { ColorPicker } from 'apps/studio/components/settings/inputs/ColorPicker'

export const SettingsColorPicker = ({
  property,
  label,
  data,
  controlLabel,
  update,
  styleLevel = 'global',
  guid = '',
}) => {
  const dispatch = useDispatch()

  // account for legacy naming
  if ('backgroundOpacity' in data) {
    data.backgroundColorOpacity = data.backgroundOpacity
  }

  const {
    [property]: color = '#FFFFFF',
    [`${property}Opacity`]: alpha,
  } = data

  const onChange = (newColor, newAlpha) => {
    const payload = {
      [property]: newColor,
    }
    if (newAlpha != null) {
      payload[`${property}Opacity`] = newAlpha
    }
    dispatch(update(payload))
  }

  const props = {
    id: `${property}-color-picker`,
    title: controlLabel,
    label,
    color,
    onChange,
    styleLevel,
    guid,
  }

  if (alpha != null) {
    props.alpha = alpha
  }

  return <ColorPicker {...props} />
}
